/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';

const OkMessage = ({ title, msg, onDismiss }) => (
    <div>
        <div className="ui message">
            <h2 className="ui center aligned icon header">
                <i className="huge smile icon"></i>
                {title}
            </h2>
            <p className="ui center aligned">{msg}</p>
            <br/>
            {onDismiss !== undefined ? <div className="ui one column grid"><div className="center aligned one column row"> <div className="column"> <a href="#" className="ui primary button" onClick={onDismiss}>ok</a></div></div> </div>:null}
        </div>
    </div>
);

export default OkMessage;


/** WEBPACK FOOTER **
 ** ./src/components/OkMessage.jsx
 **/